import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { Title } from '@angular/platform-browser';

@Component({
    // tslint:disable-next-line:component-selector
    selector: '<app-root>',
    template: '<router-outlet></router-outlet>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
    title = 'Amway ABO Pool System';

    constructor(private router: Router, private titleService: Title, private iconSetService: IconSetService) {
        titleService.setTitle(this.title);
        // iconSet singleton
        iconSetService.icons = { ...iconSubset };
    }

    ngOnInit(): void {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
        });
    }
}
